import styled from 'styled-components';
import { p } from '@lendi-ui/spacing';
import { InputButton as LUIInputButton } from '@lendi-ui/text-input';

export const InputButton = styled(LUIInputButton)`
  ${p('nil')}
`;
